import { getBrandValue } from '~/shared/utils/brandNameHelper';

const FableticsConstructorQuickViewCollectionBuilderComponent = {
  name: '_ConstructorQuickViewCollection_',
  inputs: [
    {
      name: 'productSource',
      friendlyName: 'P-Source',
      required: true,
      localized: false,
      helperText:
        'This field sets the P-Source name for tracking revenue on the page.',
      type: 'string',
    },
    {
      name: 'maxItemCount',
      helperText:
        'Maximum number of products you want displayed for this collection of products.',
      type: 'number',
    },
    {
      name: 'collectionSelection',
      type: getBrandValue({
        savage: 'SXFCollectionSelector',
        default: 'CollectionSelector',
      }), // defined in https://github.com/Fabletics/cf-builderio-constructor-plugin/blob/master/src/plugin.jsx
      friendlyName: 'Constructor Collection Selection',
      helperText:
        'In Constructor, create the Collection of products you want to include in this grid then enter the Collection label here.',
      options: {
        url: 'https://cdn.fabletics.com/media/builder-constructor/plugin.system.js',
      },
      showIf: (options: Map<string, any>) =>
        options.get('filterType') === 'Collection',
      defaultValue: null,
      required: false,
      localized: false,
    },
    {
      name: 'collectionIdOverride',
      friendlyName: 'Collection ID Override',
      type: 'string',
      defaultValue: null,
      required: false,
      localized: false,
      showIf: (options: Map<string, any>) =>
        options.get('filterType') === 'Collection',
      helperText:
        'Overrides the Constructor Collection Selector in order to use a collection ID that is not available in Constructor.',
      advanced: true,
    },
    {
      name: 'categorySelection',
      friendlyName: 'Constructor Group Selection',
      type: getBrandValue({
        savage: 'SXFCategorySelector',
        default: 'CategorySelector',
      }), // defined in https://github.com/Fabletics/cf-builderio-constructor-plugin/blob/master/src/plugin.jsx
      defaultValue: null,
      required: false,
      localized: false,
      showIf: (options: Map<string, any>) =>
        options.get('filterType') === 'Category',
      options: {
        url: 'https://cdn.fabletics.com/media/builder-constructor/plugin.system.js',
      },
      helperText:
        'Select the category for the products you want to include in this grid. You can search by either the label or the ID.',
    },
    {
      name: 'categoryIdOverride',
      friendlyName: 'Category ID Override',
      type: 'string',
      defaultValue: null,
      required: false,
      localized: false,
      showIf: (options: Map<string, any>) =>
        options.get('filterType') === 'Category',
      helperText:
        'Overrides the Constructor Group Category Selector in order to use a category ID that is not available in Constructor.',
      advanced: true,
    },
  ],
} as const;

export default FableticsConstructorQuickViewCollectionBuilderComponent;
